import { InjectionToken } from "@angular/core";

export const TOGGLE_FILTER_STATE_PROP = new InjectionToken<string>("TOGGLE_FILTER_STATE_PROP");
export const toggleFilterStatePropProvider = {
    provide: TOGGLE_FILTER_STATE_PROP,
    useValue: "toggleFilters",
};
